import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {BodyInput} from '../body.input';
import {NavParams, ViewController} from 'ionic-angular';
import {WindowService} from '../../../../../../shared/services/window';

/**
 * Class for the BodyInputModalComponent
 * @class BodyInputModalComponent
 *
 * @description used for the full screen rte experience.
 * To be used with a [ModalController]{@link https://ionicframework.com/docs/api/components/modal/ModalController/} create call from within a BodyInput
 *
 * @implements {AfterViewInit}
 *
 * @example
 * ```ts
 * const bodyModal = this.modalCtrl.create(BodyInputModalComponent, {
 *   title: this.modalHeader,
 *   value: this.getValue()
 * });
 * bodyModal.onDidDismiss((val) => this.hModalDismiss(val));
 * bodyModal.present();
 * ```
 *
 * # Expected NavParams
 * |name|type|description|
 * |--|--|--|
 * |title|string|Title for the modal header|
 * |value|string|Parent RTE value|
 */
@Component({
  selector: 'advtech-body-input-modal',
  templateUrl: './body-input-modal.component.html',
})
export class BodyInputModalComponent implements AfterViewInit {

  /**
   * The title for the modal
   * @type {string}
   */
  title: string;

  /**
   * The value of the main body input
   * @type {string}
   */
  parentValue: string;

  /**
   * The body input from the template
   * @type {BodyInput}
   */
  @ViewChild('bodyInput')
  bodyInput: BodyInput;

  /**
   * @constructor
   * @param {WindowService} windowService
   * @param {NavParams} navParams
   * @param {ViewController} viewController
   */
  constructor(public windowService: WindowService,
              private navParams: NavParams,
              private viewController: ViewController) {
    this.title = this.navParams.get('title');
    this.parentValue = this.navParams.get('value');
  }

  /** @inheritdoc */
  ngAfterViewInit(): void {
    this.bodyInput.setValue(this.parentValue);
    this.bodyInput.quillEditor.quillEditor.getModule('history').clear();

    setTimeout(() => {
      this.placeCaretAtEnd();

    }, 600);
  }

  /**
   * Dismisses the modal and passes the bodyInputs value through
   * @returns {Promise<any>}
   */
  dismiss(): Promise<any> {
    return this.viewController.dismiss({value: this.bodyInput.getValue()});
  }

  /**
   * Places the caret at the end of the last element and scrolls it there
   * @return {void}
   */
  placeCaretAtEnd(): void {
    const el = this.bodyInput.quillEditor.quillEditor.root;
    el.focus();
    const range = document.createRange();
    let sel = this.windowService.window.getSelection();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);

    if (this.parentValue !== '<p><br></p>') {
      setTimeout(() => {
        sel = this.windowService.window.getSelection();
        if (sel.rangeCount > 0) {
          el.scrollTop = el.lastElementChild.offsetTop;
        }
      }, 200);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/body-input-modal/body-input-modal.component.ts